import React, { HTMLAttributes, forwardRef } from 'react';

import { Box } from '@reckon-web/box';
import { usePack, useTheme } from '@reckon-web/theme';

import { GUTTER } from './constants';

type SegmentedControlWrapperProps = {
  block: boolean;
} & HTMLAttributes<HTMLDivElement>;
export const Wrapper = forwardRef<HTMLDivElement, SegmentedControlWrapperProps>(
  ({ block, ...props }, ref) => {
    const sizes = usePack('sizes');
    const { palette, typography } = useTheme();

    return (
      <Box
        ref={ref}
        css={{
          background: palette.segmentedControl.track,
          backgroundClip: 'padding-box',
          borderRadius: sizes.small.borderRadius,
          boxSizing: 'border-box',
          cursor: 'pointer',
          display: block ? 'flex' : 'inline-flex',
          flex: block ? 1 : undefined,
          fontSize: typography.fontSize.small,
          fontWeight: typography.fontWeight.medium,
          height: sizes.small.boxSize,
          outline: 0,
          padding: GUTTER,
          position: 'relative',
        }}
        {...props}
      />
    );
  }
);
Wrapper.displayName = 'SegmentedControlWrapper';
